import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import storage from '../utils/storage';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading, true/false = result
  
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = await storage.getItem('token');
        setIsAuthenticated(!!token);
      } catch (error) {
        console.error('Error checking authentication:', error);
        setIsAuthenticated(false);
      }
    };
    
    checkAuth();
  }, []);
  
  // Show loading while checking authentication
  if (isAuthenticated === null) {
    return <div>Loading...</div>; // You can replace this with a proper loading component
  }
  
  // If there's no token and we're trying to access a protected route
  if (!isAuthenticated) {
    // Redirect to login page with the return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute; 